import {
  getFrequencyPlanningBySchedule,
  getRrulePlanningBySchedule,
} from '@griply/utils';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';
import { WeekDays } from 'shared/types/week-days';

import { getFrequencyDueDateBySchedule } from './get-frequency-due-date-by-schedule';
import { getRruleDueDateBySchedule } from './get-rrule-due-date-by-schedule';

export type ScheduleDueDatesOptions = {
  startDate: Timestamp;
  endDate: Timestamp;
  today: Timestamp;
  weekStartsOn: WeekDays;
  uncompletedOnly?: boolean;
  sinceLastEntryOnly?: boolean;
  strictEndDate?: boolean;
};

export const getSchedulePlanning = (
  schedule: HabitSchedule,
  {
    startDate,
    endDate,
    today,
    weekStartsOn,
    uncompletedOnly,
    sinceLastEntryOnly,
    strictEndDate,
  }: ScheduleDueDatesOptions,
) => {
  if (schedule.frequency?.count) {
    return getFrequencyPlanningBySchedule(schedule, {
      startDate,
      endDate,
      today,
      weekStartsOn,
      uncompletedOnly,
      sinceLastEntryOnly,
    });
  }

  return getRrulePlanningBySchedule(schedule, {
    startDate,
    endDate,
    weekStartsOn,
    uncompletedOnly,
    sinceLastEntryOnly,
    strictEndDate,
  });
};

export type ScheduleDueDateOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const getScheduleDueDate = (
  schedule: HabitSchedule,
  { today, weekStartsOn }: ScheduleDueDateOptions,
) => {
  if (schedule.frequency?.count) {
    return getFrequencyDueDateBySchedule(schedule, { today, weekStartsOn });
  }

  return getRruleDueDateBySchedule(schedule, { today, weekStartsOn });
};
